// import Laos partners
import anourak from '../pages/aboutus/img/col/anourak-logo.jpg'
import ecc from '../pages/aboutus/img/col/ecc-logo.jpg'
import ftb from '../pages/aboutus/img/col/ftb-logo.png'
import lctw from '../pages/aboutus/img/col/lctw-logo.jpg'
import wwf from '../pages/aboutus/img/col/wwf-logo.jpg'
import cilm from '../pages/aboutus/img/col/cilm.png'
import uhs from '../pages/aboutus/img/col/uhs.png'
import nuol from '../pages/aboutus/img/col/nuol.png'
import nuol_2 from '../pages/aboutus/img/col/nuol_2.jpg'
import nahl from '../pages/aboutus/img/col/nahl.jpg'
import tphi from '../pages/aboutus/img/col/tphi.png'
import tphi_2 from '../pages/aboutus/img/col/tphi_2.jpg'
import wcs from '../pages/aboutus/img/col/wcs.jpg'
// import France partners
import mivegec from '../pages/aboutus/img/col/lg_mivegec.png'
import ird from '../pages/aboutus/img/col/ird-logo.png'
import montperiller from '../pages/aboutus/img/col/montpellier.png'
// import Thailand partners
import cmu_ams from '../pages/aboutus/img/col/amscmu.png'
import cmu_vetmed from '../pages/aboutus/img/col/vetmedcmu.jpg'
import cmu_sci from '../pages/aboutus/img/col/scicmu.jpg'
import cmu_sosci from '../pages/aboutus/img/col/soscicmu.png'
import healthdeep from '../pages/aboutus/img/col/healthdeep.png'

import pho from '../pages/aboutus/img/col/pho.jpg'
import doichiangdao from '../pages/aboutus/img/col/doichiangdao.jpg'

import mu_trop from '../pages/aboutus/img/col/mu_trop.png'
import ku_vettech from '../pages/aboutus/img/col/ku_vettech.png'

    const Worldmap = [
        {
            id: "th",
            name: "Thailand",
            x: 50,
            y:30,
            logo:[
                {id: 'cmu_ams',src: cmu_ams,href: 'https://www.ams.cmu.ac.th/main/web/' },
                {id: 'cmu_vetmed',src: cmu_vetmed,href: 'https://www.vet.cmu.ac.th/web2022/index.html' },
                {id: 'cmu_sci',src: cmu_sci,href: 'https://www.science.cmu.ac.th/prsci/index.php' },
                {id: 'cmu_sosci',src: cmu_sosci,href: 'https://soc-dev.soc.cmu.ac.th/' },
                {id: 'mu_trop', src: mu_trop, href: 'https://www.tm.mahidol.ac.th/'},
                {id: 'ku_vettech', src: ku_vettech, href:'https://www.ku.ac.th/en/faculty-of-veterinary-technology'},
                {id: 'pho', src: pho, href: 'https://www.chiangmaihealth.go.th/'},
                {id: 'doichiangdao', src: doichiangdao, href: 'https://www.dnp.go.th/wildlife/wildstation/001%20Doi%20ChaeangDao.html'},
                {id: 'healthdeep', src: healthdeep, href: 'https://sites.google.com/view/healthdeep/home?authuser=0'},
            ]
        },
        {
            id: "fr",
            name: "France",
            x: 20,
            y:5,
            logo:[
                {id: 'mivegec',src: mivegec,href: 'https://mivegec.fr/en' },
                {id: 'ird', src: ird, href: 'https://www.ird.fr/'},
                {id: 'montperiller', src: montperiller, href: 'https://sciences.edu.umontpellier.fr/en/welcome-to-the-faculty-of-sciences/'}
            ]
        },
        {
            id: "la",
            name: "Laos",
            x: 50,
            y:2,
            logo:[
                {id: 'ecc',src: ecc,href: 'https://www.elephantconservationcenter.com' },
                {id: 'wwf',src: wwf,href: 'https://www.wwf.org.la' },
                {id: 'ftb',src: ftb,href: 'https://freethebears.org' },
                {id: 'lctw',src: lctw,href: 'https://lctwildlife.org' },
                {id: 'anourak',src: anourak,href: 'https://www.conservationlaos.com' },
                {id: 'clim', src: cilm, href: 'https://www.cilm-laos.org/'},
                {id: 'uhs',src: uhs,href: 'https://uhs.edu.la/' },
                {id: 'nuol',src: nuol, src2: nuol_2,href: 'https://www.nuol.edu.la/index.php/en/' },
                {id: 'nahl', src: nahl, href: '#'},
                {id: 'tphi', src: tphi, src2: tphi_2, href: 'https://laotphi.gov.la/'},
                {id: 'wcs', src: wcs, href: 'https://laos.wcs.org/'}
            ]
        }
    ]

    const Partners = [
        {
            id: "th",
            imgSrc: cmu_ams,
            name: 'Faculty of Associated Medical Sciences, Chiang Mai University',
            country: "Thailand",
            describe: `<ul>
                <li>Produce graduates with morality, quality, and global citizenship skills.</li>
                <li>Conduct research to create knowledge and innovations aligned with national policies, promoting the health of communities and society.</li>
                <li>Provide academic services to strengthen and sustain health within communities and society.</li>
                <li>Preserve Lanna-Thai culture and protect the environment to maintain the uniqueness of the local heritage.</li>
                <li>To manage the organization for high performance, digitalization, and global standards, ensuring excellent results and employee satisfaction.</li>
            </ul>`,
            href: `https://www.ams.cmu.ac.th/main/web/`
        },
        {
            id: "th",
            imgSrc: cmu_vetmed,
            name: 'Faculty of Veterinary Medicine, Chiang Mai University',
            country: "Thailand",
            describe: `<ul>
                <li>Organize <b>higher education and vocational education</b> with a focus on academic excellence. Graduates must be of quality according to international standards and be knowledgeable and virtuous, in accordance with the philosophy of sufficiency economy.</li>
                <li>Produce veterinary research to <b>support teaching and technology transfer</b> for the development of the country's economy and society.</li>
                <li>Providing academic <b>services to society and participating in developing strong communities</b> with the philosophy of sufficiency economy.</li>
                <li>Preserve religion, arts and culture, conserve and <b>develop natural resources and the environment sustainably</b> to create the unique identity of the northern region.</li>
                <li>Develop a management system with good <b>governance principles and self-reliance</b> using the Sufficiency Economy Philosophy.</li>
            </ul>`,
            href: `https://www.vet.cmu.ac.th/web2022/index.html`
        },
        {
            id: "th",
            imgSrc: cmu_sci,
            name: 'Faculty of Sciences, Chiang Mai University',
            country: "Thailand",
            describe: `<ul>
                <li>Produce high-quality graduates.</li>
                <li>Conduct excellent research.</li>
                <li>Provide academic services that benefit society.</li>
            </ul>`,
            href: `https://www.science.cmu.ac.th/2022/`
        },
        {
            id: "th",
            imgSrc: cmu_sosci,
            name: 'The Department of Social Science and Development, Faculty of Social Sciences, Chiang Mai University',
            country: "Thailand",
            describe: '<b>The Department of Social Science and Development</b> at Chiang Mai University specialises in teaching and research in various sub-fields social sciences, such as Ethnicity and Development, Health Social Science, Development Studies, and Political Economy. Key topics of focus include <b>environment and natural resource problems, land issues, migration and transnationalism, ethnic minorities, health, and gender issues</b>. The department focuses on these issues as they manifest themselves throughout mainland Southeast Asia.',
            href: `https://soc-dev.soc.cmu.ac.th/`
        },
        {
            id: "th",
            imgSrc: mu_trop,
            name: 'Faculty of Tropical Medicine, Mahidol University',
            country: "Thailand",
            describe: `<ul>
                <ul><b>Research Excellence in Tropical Diseases :</b>
                    <li>To conduct and promote high-caliber research in tropical diseases.</li>
                    <li>To collaborate with global partners in advancing tropical medicine research.</li>
                </ul>
                <ul><b>Educational Leadership :</b>
                    <li>To develop and implement comprehensive educational programs in tropical medicine. To prepare students and professionals with the expertise needed to combat tropical diseases.</li>
                </ul>
                <ul><b>Medical and Academic Services :</b>
                    <li>To provide specialized medical services for the prevention, diagnosis, and treatment of tropical diseases.</li>
                    <li>To offer academic services and consultations in the field of tropical medicine.</li>
                </ul>
                <ul><b>Development and Support:</b>
                    <li>To establish and support centers of excellence in various aspects of tropical medicine.</li>
                    <li>To maintain and enhance facilities for research, education, and medical services.</li>
                    <li>The Faculty's commitment to these areas ensures the advancement of knowledge in tropical medicine, the development of innovative treatments, and the promotion of health and well-being in tropical regions.</li>
                </ul>
           </ul>`,
            href: `https://www.tm.mahidol.ac.th/`
        },
        {
            id: "th",
            imgSrc: ku_vettech,
            name: 'Faculty of Veterinary Technology, Kasetsart University',
            country: "Thailand",
            describe: `<ul>
                <li>To <b>promote and expand Knowledge</b> of the Land that encourages national sustainable development in all sectors of society.</li>
                <li>To <b>continuously develop and improve on academic programs</b> that are recognized internationally for educational and research excellence.</li>
                <li>To <b>ensure high quality, operational efficiencies</b> that will achieve of the universities' mission and goals.</li>
                <li>To apply principles of good governance that ensure <b>sustainable management of the universities' resources, people and assets</b>.</li>
                <li>To continuously improve the universities' <b>administrative skills and competencies, and to ensure effective management</b> by embracing technology changes.</li>
            </ul>`,
            href: `https://www.ku.ac.th/en/faculty-of-veterinary-technology`
        },
        {
            id: "th",
            imgSrc: pho,
            name: 'Chiang Mai Province Public Health Office',
            country: "Thailand",
            describe: `<ul>
                <li><b>Promote, prevent, and control diseases</b> and health threats while ensuring consumer health protection effectively.</li>
                <li><b>Develop the healthcare system</b> to ensure quality, efficiency, and equity.</li>
                <li><b>Encourage participation</b> from all sectors in managing and improving the healthcare system.</li>
                <li><b>Enhance management systems</b> with a focus on achieving tangible results.</li>
            </ul>`,
            href: `https://www.chiangmaihealth.go.th/`
        },
        {
            id: "th",
            imgSrc: doichiangdao,
            name: 'Doi Chiang Dao Wildlife Research Station',
            country: "Thailand",
            describe: `<ul>
                <li><b>Survey</b> the species, habitat distribution of wildlife, and ecosystems in Northern Thailand.</li>
                <li><b>Collect wildlife and plant samples for research</b> purposes.</li>
                <li><b>Explore techniques</b> for studying wildlife.</li>
                <li><b>Facilitate collaboration</b> with other researchers conducting fieldwork.</li>
                <li><b>Provide academic services and disseminate research knowledge</b> to students and the general public.</li>
            </ul>`,
            href: `https://www.dnp.go.th/wildlife/wildstation/001%20Doi%20ChaeangDao.html`
        },
        {
            id: "th",
            imgSrc: healthdeep,
            // name: 'Health, Disease, Ecology, Environment and Policy',
            country: "Thailand",
            describe: `<b>The three main objectives of the International Reseach Laboratory HealthDEEP:</b>
            <ul>
                <li>to develop <b>collaborative research</b> on the transmission of diseases at the wildlife / livestock / environment interface in <b>One Health</b> approach</li>
                <li>to contribute to the development of <b>land-based solutions</b> as integrated strategies for resilient territories (One Health, climate change, biodiversity)</li>
                <li>to enhance the <b>science / policy dialogue</b> in Global Health / One Health / Planetary Health.</li>
            </ul>`,
            href: `https://sites.google.com/view/healthdeep/home?authuser=0`
        },
        {
            id: 'laos',
            imgSrc: ecc,
            name: 'Elephant Conservation Center',
            country: "Laos",
            describe: `The Elephant Conservation Center works on the <b>preservation of the Lao elephant population</b>, both wild and those under human care. With the former increasingly under pressure (poaching, deforestation…) and the latter declining due to ageing, over-exploitation and illegal exports, solutions are <b>urgently needed</b>.
They secure a <b>healthy population</b> of elephants under human care to act as a <b>genetic reservoir</b> if the wild elephant population were to collapse. To achieve this, they need <b>improved veterinary care and elephant welfare regulations so as to increase the birth rate</b>.
They also need to <b>secure natural habitats for wild populations and captive elephants suitable for rewilding</b>. This is what they are trying to achieve within the Nam Pouy National Protected Area.`,
            href: 'https://www.elephantconservationcenter.com' 
        },
        {
            id: 'laos',
            imgSrc: wwf,
            name: 'World Wide Fund for Nature',
            country: 'Laos',
            describe: `WWF’s mission is to <b>stop the degradation of the planet’s natural environment</b> and <b>build a future in which humans live in harmony with nature</b>, by:
                        <ul>
                            <li>Conserving the world’s biological diversity</li>
                            <li>Ensuring that the use of renewable natural resources is sustainable</li>
                            <li>Promoting the reduction of pollution and wasteful consumption </li>
                        </ul>
To do this, WWF uses the best available scientific information to find solutions to today’s pressing conservation issues. They seek dialogue by building relationships with government, other conservation-focused organisations, industry and communities to deliver our goals.`,
            href: 'https://www.wwf.org.la' 
        },
        {
            id: 'laos',
            imgSrc: ftb,
            name: 'Free the Bears',
            country: "Laos",
            describe: `<ul>
                <li><b>Create and support</b> world-class bear sanctuaries; government owned, managed to the highest level of welfare and striving towards long-term sustainability</li>
                <li><b>Develop alternative sustainable livelihood programmes</b> for the community to prevent impoverished families from exploiting bears for profit</li>
                <li><b>Strengthen wildlife law enforcement</b> efforts through advocacy and training</li>
                <li><b>Protect wild bear populations</b> through community-led efforts and increased understanding of wild bear populations</li>
                <li><b>Build the capacity of local partners and staff</b> including government authorities, veterinarians, researchers, school-teachers, and animal care staff</li>
            </ul>`,
            href: 'https://freethebears.org' 
        },
        {
            id: 'laos',
            imgSrc: lctw,
            name: 'Lao Conservation Trust for Wildlife',
            country: 'Laos',
            describe: `Thier Mission is to <b>work jointly with key conservation stakeholders</b>, both within Laos and internationally, 
            <b>to end the illegal wildlife trade</b>. They rescue, rehabilitate, and release native wildlife affected by this trade. 
            In addition, they <b>build animal welfare and conservation capacity</b> through engagement and outreach across Lao PDR.`,
            href: 'https://lctwildlife.org' 
        },
        {
            id: 'laos',
            imgSrc: anourak,
            name: 'Association Anoulak',
            country: 'Laos',
            describe: `<b>Association Anoulak</b> (conservation in Lao language) is a French-registered association (registered in September 2014) dedicated to the long-term conservation of biodiversity and human minority communities resilience in Lao People’s Democratic Republic (Lao PDR or Laos), in particular in the Annamite Mountains

<br/><b>Association Anoulak implements activities on:</b>
        <ul>
            <li>Biodiversity research and monitoring for conservation.</li>
            <li>Community anti-poaching patrols.</li>
            <li>Community outreach and awareness raising.</li>
            <li>Community sustainable livelihoods.</li>
            <li>Capacity building</li>
        </ul>`,
            href: 'https://www.conservationlaos.com' 
        }, 
        {
            id: 'laos',
            imgSrc: cilm,
            name: 'The Centre d’Infectiologie Christophe Mérieux of Laos (CILM)',
            country: 'Laos',
            describe: `
            <ul>
                <li><b>Research</b>: we develop scientific research programs in Laos in partnership with various scientific and medical institutions.</li>
                <li><b>Laboratory testing</b>: we carry out specialized molecular biological analyses in line with nationwide programs to fight infectious diseases.</li>
                <li><b>Quality results</b>: we are committed to delivering high-quality, reliable test results for all patients in compliance with international and ISO standards while providing a safe environment for all staff and patients.</li>
                <li><b>Training for health professionals</b>: we work with partners at public hospital labs, the University of Health Sciences, and IFMT to provide training for health professionals.</li>
            </ul>`,
            href: 'https://www.cilm-laos.org/' 
        },
        {
            id: 'laos',
            imgSrc: uhs,
            name: 'University of Health Sciences Laos',
            country: 'Laos',
            describe: `<b>Roles and Responsibilities</b>
<br/>Each sector within the organizational structure of the University of Health Sciences (UHS) actively fulfills its responsibilities by implementing various activities in alignment with the party's policies, as well as the Ministry of Public Health’s reform strategies. The university places emphasis on its vision and mission, ensuring the development of public health personnel with knowledge, skills, expertise, and professional ethics. These individuals are equipped to serve society, conduct scientific research, and promote Lao cultural heritage.
<br/>Beyond delivering academic programs, UHS also organizes extracurricular activities such as national defense education, arts and literature, and workforce development. Additionally, the university collaborates with various international organizations in multiple countries to enhance faculty qualifications and improve teaching and learning standards.`,
            href: 'https://uhs.edu.la/' 
        },
        {
            id: 'laos',
            imgSrc: nuol,
            imgSrc2: nuol_2,
            name: 'National University of Laos',
            country: 'Laos',
            describe: '',
            href: 'https://www.nuol.edu.la/index.php/en/' 
        },
        {
            id: 'laos',
            imgSrc: nahl,
            name: 'National Animal Health Laboratory',
            country: 'Laos',
            describe: '',
            href: '#' 
        },
        {
            id: 'laos',
            imgSrc: tphi,
            imgSrc2: tphi_2,
            name: 'Lao Tropical and Public Health Institute',
            country: 'Laos',
            describe: ``,
            href: 'https://laotphi.gov.la/' 
        },
        {
            id: 'laos',
            imgSrc: wcs,
            name: 'The Wildlife Conservation Society',
            country: 'Laos',
            describe: `Thier vision at the Lao PDR Program is that the unique ecosystems of Lao PDR thrive indefinitely and are valued by the people of Lao PDR, and the world, for their biodiversity, natural beauty, and the services they provide to humanity. A core thematic to support that vision is protection and improved management of biodiversity values by building the capacity of government and local stakeholders, improving management of wildlife and wild places through community engagement, and combatting illegal wildlife trade.`,
            href: 'https://laos.wcs.org/' 
        },
        {
            id: 'fr',
            imgSrc: mivegec,
            name: 'Maladies Infectieuses et Vecteurs : Ecologie, Génétique, Evolution et Contrôle',
            country: "France",
            describe: `To employ integrative and transdisciplinary research to understand the mechanisms and genetic and non-genetic determinants behind the maintenance, amplification, and transmission of pathogenic agents in order to better comprehend the evolution of these infectious systems and to improve the ways in which we control them.`,
            href: 'https://mivegec.fr/en' 
        },
        {
            id: 'fr', 
            imgSrc: ird, 
            name: "l'Institut de recherche pour le développement (IRD)",
            country: "France",
            describe: `<b>Institut de Recherche pour le Développement (the French National Research Institute for Sustainable Development) is an internationally recognised multidisciplinary organisation, working mainly in partnership with countries in the Global South and in the French overseas territories.</b>
            <br/>IRD is a multidisciplinary French public research organization committed to equitable partnerships with countries in the Global South and in the French overseas territories for nearly 80 years.
            <br/>As a contributor to the achievement of the international development agenda, the IRD aligns its priorities with the implementation of the Sustainable Development Goals (SDGs).
            <br/>Together, scientists and the Institute's partners propose concrete solutions to the global challenges facing societies and the planet. This win-win relationship makes science and innovation major levers for development.
            <br/>The Institute operates under the joint authority of the ministry responsible for higher education and research as well as the ministry for european and foreign affairs.`,
            href: 'https://www.ird.fr/'
        },
        {
            id: 'fr', 
            imgSrc: montperiller, 
            name: 'Faculty of Sciences, University of Montpellier',
            country: 'France',
            describe: `<b>The main mission of the Montpellier Faculty of Science, part of the University of Montpellier, is to offer students a complete range of higher education courses in the sciences, both initial and continuing.</b>
            <ul>
                <li>Initial and continuing lifelong training</li>
                <li>Scientific and technological research, and the dissemination and valorization of its results for the benefit of society. The latter is based on the development of innovation, technology transfer where possible, expertise and support for associations and foundations recognized as being in the public interest, and public policies designed to meet societal challenges and social, economic and sustainable development needs</li>
                <li>Guidance, social promotion and professional integration</li>
                <li>The dissemination of humanist culture, in particular through the development of human and social sciences, and scientific, technical and industrial culture</li>
                <li>Participating in the construction of the European Higher Education and Research Area</li>
                <li>International cooperation</li>
            </ul>
            `,
            href: 'https://sciences.edu.umontpellier.fr/en/welcome-to-the-faculty-of-sciences/'}

    ]


export {Worldmap, Partners}